const CLOCK_TIME = /^([01]?\d|2[0-3]):([0-5]\d)(?::[0-5]\d)?$/;

/**
 * Minutes since midnight of a time of day `H:mm`, `HH:mm` or `HH:mm:ss`, up to 23:59. Anything
 * else is null.
 */
export const clockTimeToMinutes = (time?: string | null): number | null => {
  const match = CLOCK_TIME.exec(time?.trim() ?? '');
  if (!match) {
    return null;
  }

  const [, hours, minutes] = match;
  return Number(hours) * 60 + Number(minutes);
};
